import React from 'react'
import { JuggleLoading } from '../../Components'

import './LoadingScreen.scss'

export default function LoadingScreen () {
    return <div className="LoadingScreen">
        <JuggleLoading pretitle='Estamos cargando tu información' message='Prueba App Live by Contingente' subtitle='11 de mayo de 2022' />
    </div>
}